import * as types from './types';
import { GenericExportSetupFieldEnum as Fields } from 'Common/FieldEnum';
import _ from 'lodash';

const INITIAL_STATE = {
  exportFileTypes: [],
  exportFileType: null,
  exportFileTypeFuture: null,
  gridData: [],
  constantValues: [],
  loading: false,
  submitting: false,
  saveSuccessful: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.GENERIC_EXPORT_SETUP_GET_EXPORTFILETYPE: {
      return {
        ...state,
        exportFileTypes: payload.Data,
      };
    }
    case types.GENERIC_EXPORT_SETUP_GET_EXPORTFILEFIELD: {
      const exportMapping = _.find(payload.Data, x => {
        return x.Mapped === true;
      });

      return {
        ...state,
        gridData: payload.Data,
        exportFileType: payload.exportFileType,
        constantValues: payload.Data.map(x => {
          return {
            [Fields.Id]: x.Id,
            [Fields.ConstantValue]: x.ConstantValue,
          };
        }),
        exportMappingList: !exportMapping
          ? {}
          : exportMapping.ExportMappingList.reduce(
              (acc, item) => ({ ...acc, [item.SourceValue]: item.MappedValue }),
              {}
            ),
      };
    }
    case types.GENERIC_EXPORT_SETUP_SET_LOADING: {
      return {
        ...state,
        loading: payload,
      };
    }
    case types.GENERIC_EXPORT_SETUP_SET_SUBMITTING: {
      return {
        ...state,
        submitting: payload,
      };
    }
    case types.GENERIC_EXPORT_SETUP_SET_SUCCESSFUL: {
      return {
        ...state,
        saveSuccessful: payload,
      };
    }
    case types.GENERIC_EXPORT_SETUP_ERROR:
      return { ...state, error: payload };
    case types.GENERIC_EXPORT_SETUP_CLEAR_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPE:
      return { ...state, exportFileType: payload };
    case types.GENERIC_EXPORT_SETUP_SET_EXPORTFILETYPEFUTURE:
      return { ...state, exportFileTypeFuture: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/genericexportsetup/state/setup/reducer.js